import React from 'react';

import {useMediaSettingsState} from '../../contexts/MediaSettingsContextProvider';
import {BoundingBoxClasses} from './BoundingBoxClasses';

export const BoundingBoxesForMediaKey = ({
  mediaKey,
  boxQueryRegex,
}: {
  mediaKey: string;
  boxQueryRegex: RegExp;
}) => {
  const {allBoxes} = useMediaSettingsState();
  const relevantMasks = allBoxes[mediaKey];
  return (
    <div className="pt-16">
      {Object.keys(relevantMasks).map(boxKey => {
        return (
          <BoundingBoxClasses
            boxKey={boxKey}
            mediaKey={mediaKey}
            key={`${mediaKey}-${boxKey}`}
            boxQueryRegex={boxQueryRegex}
          />
        );
      })}
    </div>
  );
};
